import React, { useEffect } from "react";
import LayersIcon from '@mui/icons-material/Layers';
import ScienceIcon from '@mui/icons-material/Science';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import WaterDropIcon from '@mui/icons-material/WaterDrop';

const ElaboracionClasesSection = ({
  elaboracionRecords,
  granelRecords,
  isFormOpen,
  setIsFormOpen,
  fechaIngreso,
  setFechaIngreso,
  loteOrigen,
  setLoteOrigen,
  volumenOrigen,
  setVolumenOrigen,
  pctAlcOrigen,
  setPctAlcOrigen,
  categoriaOrigen,
  setCategoriaOrigen,
  claseOrigen,
  setClaseOrigen,
  ingredientesOrigen,
  setIngredientesOrigen,
  edadOrigen,
  setEdadOrigen,
  analisisOrigen,
  setAnalisisOrigen,
  tipoMagueyOrigen,
  setTipoMagueyOrigen,
  ingredientesAdicionados,
  setIngredientesAdicionados,
  procesoRealizado,
  setProcesoRealizado,
  descripcionProceso,
  setDescripcionProceso,
  fechaSalida,
  setFechaSalida,
  loteSalida,
  setLoteSalida,
  volumenSalida,
  setVolumenSalida,
  pctAlcSalida,
  setPctAlcSalida,
  claseSalida,
  setClaseSalida,
  observaciones,
  setObservaciones,
  handleSaveElaboracion
}) => {

  // Auto-fill features when selecting a source bulk lot
  useEffect(() => {
    if (loteOrigen && loteOrigen !== "manual") {
      const selected = granelRecords.find(r => r.noLote === loteOrigen);
      if (selected) {
        setFechaIngreso(selected.fechaMovimiento);
        setVolumenOrigen(selected.invFinalVol);
        setPctAlcOrigen(selected.invFinalAlc);
        setCategoriaOrigen(selected.categoria);
        setClaseOrigen(selected.clase);
        setIngredientesOrigen(selected.ingrediente);
        setEdadOrigen(selected.edad);
        setAnalisisOrigen(selected.noAnalisis);
        setTipoMagueyOrigen(selected.tipoMaguey);
      }
    }
  }, [loteOrigen, granelRecords, setFechaIngreso, setVolumenOrigen, setPctAlcOrigen, setCategoriaOrigen, setClaseOrigen, setIngredientesOrigen, setEdadOrigen, setAnalisisOrigen, setTipoMagueyOrigen]);

  if (!isFormOpen) {
    return (
      <div className="animate-fadeIn">
        <div className="history-section-header">
          <h2>Elaboración de las Clases, Reprocesos y Reacondicionamientos (Sección VI)</h2>
          <button 
            onClick={() => setIsFormOpen(true)}
            className="btn-add-new"
          >
            <AddIcon style={{ fontSize: 18 }} />
            <span>Nuevo Registro Sección VI</span>
          </button>
        </div>

        <div className="records-list-wrapper">
          <table className="records-table">
            <thead>
              <tr>
                <th colSpan="10" style={{ textAlign: "center", background: "rgba(107, 142, 35, 0.2)", color: "var(--agave-green)" }}>Características del Mezcal Antes del Proceso</th>
                <th colSpan="3" style={{ textAlign: "center", background: "rgba(210, 105, 30, 0.2)", color: "var(--copper)" }}>Procesamiento del Mezcal</th>
                <th colSpan="5" style={{ textAlign: "center", background: "rgba(107, 142, 35, 0.2)", color: "var(--agave-green)" }}>Resultado del Proceso</th>
                <th colSpan="3" style={{ textAlign: "center" }}>Finalización</th>
              </tr>
              <tr>
                <th>Fecha Ingreso</th>
                <th>Lote</th>
                <th>Volumen (L)</th>
                <th>% Alc. Vol.</th>
                <th>Categoría</th>
                <th>Clase</th>
                <th>Ingrediente(s)</th>
                <th>Edad</th>
                <th>Nº Análisis</th>
                <th>Tipo Maguey</th>
                
                <th>Ingredientes Adicionados</th>
                <th>Proceso</th>
                <th>Descripción</th>
                
                <th>Fecha Salida</th>
                <th>Lote</th>
                <th>Volumen (L)</th>
                <th>% Alc. Vol.</th>
                <th>Clase</th>
                
                <th>Observaciones</th>
                <th>V.Bo. Inspector</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {elaboracionRecords.map((rec, i) => (
                <tr key={i}>
                  <td>{rec.fechaIngreso}</td>
                  <td style={{ fontWeight: 800 }}>{rec.loteOrigen}</td>
                  <td>{rec.volumenOrigen} L</td>
                  <td>{rec.pctAlcOrigen}%</td>
                  <td>{rec.categoriaOrigen}</td>
                  <td>{rec.claseOrigen}</td>
                  <td>{rec.ingredientesOrigen}</td>
                  <td>{rec.edadOrigen}</td>
                  <td>{rec.analisisOrigen}</td>
                  <td>{rec.tipoMagueyOrigen}</td>
                  
                  <td>{rec.ingredientesAdicionados}</td>
                  <td>
                    <span className="badge-status" style={{ background: "rgba(210, 105, 30, 0.15)", color: "var(--copper)" }}>
                      {rec.procesoRealizado}
                    </span>
                  </td>
                  <td style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {rec.descripcionProceso}
                  </td>
                  
                  <td>{rec.fechaSalida}</td>
                  <td style={{ fontWeight: 800, color: "var(--agave-green)" }}>{rec.loteSalida}</td>
                  <td><strong>{rec.volumenSalida} L</strong></td>
                  <td>{rec.pctAlcSalida}%</td>
                  <td>{rec.claseSalida}</td>
                  
                  <td style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {rec.observaciones}
                  </td>
                  <td style={{ fontSize: "11px" }}>{rec.inspector}</td>
                  <td>
                    <span className={`badge-status ${rec.status}`}>
                      {rec.status === "aprobado" ? "Aprobado" : rec.status === "revision" ? "En revisión" : "Borrador"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-fadeIn">
      <div className="history-section-header">
        <button onClick={() => setIsFormOpen(false)} className="btn-secondary-custom" style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px" }}>
          <ArrowBackIcon style={{ fontSize: 16 }} />
          <span>Volver al Historial</span>
        </button>
        <h2>Nueva Elaboración de Clases / Reprocesos (Sección VI)</h2>
      </div>

      <div className="cards-container-grid">
        {/* CARACTERISTICAS DEL MEZCAL ANTES DEL PROCESO */}
        <section className="detail-card detail-card-accent-left-green">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <LayersIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Antes del Proceso</h2>
              <p>Características del mezcal a transformar</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <select 
                value={loteOrigen} 
                onChange={e => setLoteOrigen(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="manual">Ingreso Manual (Sin lote pre-registrado)</option>
                {granelRecords.map((r, idx) => (
                  <option key={idx} value={r.noLote}>
                    {r.noLote} (Volumen: {r.invFinalVol} L)
                  </option>
                ))}
              </select>
              <label className="custom-input-label">Lote Origen</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="date" 
                value={fechaIngreso} 
                onChange={e => setFechaIngreso(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Fecha de Ingreso</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                value={volumenOrigen} 
                onChange={e => setVolumenOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Volumen (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                step="0.1"
                value={pctAlcOrigen} 
                onChange={e => setPctAlcOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">% Alc. Vol.</label>
              <span className="input-suffix">%</span>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <select 
                value={categoriaOrigen} 
                onChange={e => setCategoriaOrigen(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="Mezcal">Mezcal</option>
                <option value="Mezcal Artesanal">Mezcal Artesanal</option>
                <option value="Mezcal Ancestral">Mezcal Ancestral</option>
              </select>
              <label className="custom-input-label">Categoría Origen</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={claseOrigen} 
                onChange={e => setClaseOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Clase Origen</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                value={ingredientesOrigen} 
                onChange={e => setIngredientesOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Ingrediente(s) Origen</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={edadOrigen} 
                onChange={e => setEdadOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Edad Origen</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                value={analisisOrigen} 
                onChange={e => setAnalisisOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Análisis Fisicoquímico</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={tipoMagueyOrigen} 
                onChange={e => setTipoMagueyOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Tipo de Maguey</label>
            </div>
          </div>
        </section>

        {/* PROCESAMIENTO DEL MEZCAL */}
        <section className="detail-card detail-card-accent-left-copper">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-copper">
              <WaterDropIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Procesamiento del Mezcal</h2>
              <p>Operación de valor agregado o reproceso</p>
            </div>
          </header>

          <div className="custom-input-group">
            <input 
              type="text" 
              value={ingredientesAdicionados} 
              onChange={e => setIngredientesAdicionados(e.target.value)} 
              className="custom-input-field"
              placeholder="Ej. Gusano de maguey, pechuga de pavo, damiana"
            />
            <label className="custom-input-label">Ingredientes Adicionados (Orden Cuantitativo)</label>
          </div>

          <div className="custom-input-group">
            <select 
              value={procesoRealizado} 
              onChange={e => setProcesoRealizado(e.target.value)}
              className="custom-select-field"
              style={{ padding: "18px 16px 8px 16px" }}
            >
              <option value="ABOCADO CON">ABOCADO CON</option>
              <option value="DESTILADO CON">DESTILADO CON</option>
              <option value="REPROCESO Y/O REACONDICIONAMIENTO">REPROCESO Y/O REACONDICIONAMIENTO</option>
            </select>
            <label className="custom-input-label">Proceso Realizado</label>
          </div>

          <div className="custom-input-group" style={{ marginTop: 20 }}>
            <textarea 
              value={descripcionProceso} 
              onChange={e => setDescripcionProceso(e.target.value)} 
              className="custom-input-field"
              style={{ height: "80px", resize: "none", padding: "14px" }}
              placeholder="Breve descripción del proceso realizado..."
            />
            <label className="custom-input-label">Descripción Breve del Proceso</label>
          </div>
        </section>

        {/* RESULTADO DEL PROCESO */}
        <section className="detail-card detail-card-accent-left-green" style={{ gridColumn: "1 / -1" }}>
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <ScienceIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Resultado del Proceso</h2>
              <p>Especificaciones finales obtenidas del lote</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="date" 
                value={fechaSalida} 
                onChange={e => setFechaSalida(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Fecha de Salida</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={loteSalida} 
                onChange={e => setLoteSalida(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Lote Final Obtenido</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                value={volumenSalida} 
                onChange={e => setVolumenSalida(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Volumen Final (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                step="0.1"
                value={pctAlcSalida} 
                onChange={e => setPctAlcSalida(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">% Alc. Vol. Final</label>
              <span className="input-suffix">%</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={claseSalida} 
                onChange={e => setClaseSalida(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Clase Final Obtenida</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 20 }}>
            <textarea 
              value={observaciones} 
              onChange={e => setObservaciones(e.target.value)} 
              className="custom-input-field"
              style={{ height: "80px", resize: "none", padding: "14px" }}
              placeholder="Notas generales..."
            />
            <label className="custom-input-label">Observaciones</label>
          </div>
        </section>
      </div>

      <div className="button-row">
        <button type="button" className="btn-secondary-custom" onClick={() => setIsFormOpen(false)}>Volver</button>
        <button 
          type="button" 
          className="btn-primary-custom" 
          onClick={() => handleSaveElaboracion("revision")}
        >
          <CheckCircleIcon style={{ fontSize: 16 }} />
          <span>Registrar Sección VI</span>
        </button>
      </div>
    </div>
  );
};

export default ElaboracionClasesSection;
